import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import classes from './Toast.module.scss';
import classNames from 'classnames';
import { useTypedDispatch } from '@hooks/useTypedDispatch';
import { CrossCircleIcon, CrossIcon, InfoCircleIcon, CheckCircleIcon, ProgressCircleIcon } from '@icons';
const textIconMap = {
    info: _jsx(InfoCircleIcon, { containerClasses: classes.textIcon }),
    error: _jsx(CrossCircleIcon, { containerClasses: classes.textIcon }),
    success: _jsx(CheckCircleIcon, { containerClasses: classes.textIcon }),
};
const Toast = ({ variant, text, id }) => {
    const { toastModel: { hideToast }, } = useTypedDispatch();
    const [animationClass, setAnimationClass] = useState(classes.visible);
    const handleProgressEnd = (ev) => {
        ev.preventDefault();
        if (ev.animationName === classes.stroke) {
            handleClose();
        }
    };
    const handleAnimationEnd = (ev) => {
        if (ev.animationName === classes.hide) {
            hideToast(id);
        }
    };
    const handleClose = () => setAnimationClass(classes.hidden);
    return (_jsxs("div", { className: classNames(classes.container, classes[variant], animationClass), onAnimationEnd: handleAnimationEnd, children: [_jsxs("div", { className: classes.text, children: [textIconMap[variant], _jsx("small", { children: text })] }), _jsxs("div", { className: classes.progress, children: [_jsx(ProgressCircleIcon, { containerClasses: classes.circleIcon, onProgressEnd: handleProgressEnd }), _jsx("button", { className: classes.buttonClose, onClick: handleClose, children: _jsx(CrossIcon, { iconClasses: "secondary", containerClasses: classes.closeIcon }) })] })] }));
};
export default Toast;
